





































import { State, Action, Getter, Mutation } from "vuex-class";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { pageDataType, componentDataType } from "../types";

import { HOST } from "../global";
import { FETCH_ANNUAL_REPORTS } from "../store/actions.names";

@Component({
  name: "AnnualSatement"
})
export default class AnnualSatement extends Vue {
  @Prop() compData: any;
  reports: any[] = [];
  public HOST: string = HOST;
  @Action(FETCH_ANNUAL_REPORTS) fetchAnnualReports: any;
  mounted() {
    this.fetchAnnualReports().then((data: any) => {
      this.reports = data.sort(function(a: any, b: any) {
        return b.year - a.year;
      });
    });
  }
}
